// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2v1qo","tabsBox":"styles_tabsBox__dm7DV","createButton":"styles_createButton__3Kw3I"};